import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import LinearProgress from '@mui/material/LinearProgress';

class CheckOver extends Component {
    constructor(props) {
      super(props);
      this.state = {
      };
    }

    componentDidMount() {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      let code = params.get('code');
      this.props.actions.checkOverUser(code);
    }
      
    render() {
       return (
        <div>
          <div style = {{display: 'flex',
            flexDirection: 'column'}}>
            <BasicPageComponent
              children = {
                <ScreenContainer>
                  
                  <div>{1==1 ?
                  <div style={{maxWidth: 500}} className='divcenter'>
                    <h3 style={{fontFamily:'Gilroy',color:'#28a5ad',margin:'auto',width:'50%',padding:'10px'}}>LÜTFEN BEKLEYİN</h3>
                    <br />
                    <LinearProgress />
                    <br />
                    <LinearProgress/>
                  </div> :
                  null }</div>
              </ScreenContainer>
              }
            />       
          </div>
        </div>
      );
    }
  }

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
  });

  export default compose(
    connect(
      null,
      mapDispatchToProps
    )
  )(CheckOver);